import * as React from "react";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import { MAP_TILE_CONFIG } from "@racoon/lib";
import type { Geofence } from "~/shared/lib/geofence";
import { GeofenceEditor, type GeofenceDraft } from "~/shared/ui/geofence-editor/geofence-editor";

/**
 * A modal's map: the onboarding wizard's, and the order form's. Not MapWithGeofence: that one calls useInfoPanel → useNavigate,
 * and modals mount outside the router.
 */

const Recenter: React.FC<{ center: [number, number]; zoom: number }> = ({ center, zoom }) => {
  const map = useMap();
  const [lat, lon] = center;
  React.useEffect(() => {
    map.setView([lat, lon], zoom);
  }, [lat, lon, zoom, map]);
  return null;
};

export const LocationMap: React.FC<{
  center: [number, number];
  pin: [number, number] | null;
  geofences: Geofence[];
  /** Omitted for a site being viewed rather than drawn — hides the edit toolbar. */
  onChange?: (draft: GeofenceDraft) => void;
  zoom?: number;
}> = ({ center, pin, geofences, onChange, zoom = 15 }) => (
  <MapContainer
    center={center}
    zoom={zoom}
    zoomControl={false}
    scrollWheelZoom
    doubleClickZoom={false}
    className="h-full w-full"
  >
    <Recenter center={center} zoom={zoom} />
    <TileLayer attribution={MAP_TILE_CONFIG.attributionShort} url={MAP_TILE_CONFIG.url} />
    <GeofenceEditor pin={pin} geofences={geofences} onChange={onChange} />
  </MapContainer>
);
